import { Component, OnInit } from '@angular/core'
import { SharedServices } from '../../../services/shared.services'
import { AuthService } from '../../../services/auth.services'
import { RestServices } from '../../../services/rest.services'
import { FormBuilder } from '@angular/forms'

@Component({
    selector: 'app-client',
    templateUrl: './client.component.html',
    styleUrls: ['./client.component.css'],
})
export class ClientComponent implements OnInit {
    auth: any
    filterLang: string
    showOption: any
    en = {}
    showEN = true
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    styleVisibility: any

    constructor(private _sharedService: SharedServices,
                private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder) {
    }

    ngOnInit() {
        if (this.langDefault) {
            this.styleVisibility = { visibility: 'visible' }
        }
        this.auth = this.authData.getUser()
        this.en = this.authData.showLang(true)
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client/client.component.ts